import RoutedSavableApp from 'platform/forms/save-in-progress/RoutedSavableApp';
import { useBrowserMonitoring } from 'platform/monitoring/Datadog';
import { DowntimeNotification } from 'platform/monitoring/DowntimeNotification';
import {
  healthAppsBeforeSend,
  selectIsAppLoading,
} from 'platform/shared/health-apps';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import formConfig from '../config/form';
import { useDefaultFormData } from '../hooks/useDefaultFormData';
import content from '../locales/en/content.json';
import manifest from '../manifest.json';
import { FORM_TOGGLES } from '../utils/constants';

const BROWSER_MONITORING_PROPS = {
  service: manifest.datadog.service,
  beforeSend: healthAppsBeforeSend,
};

const App = ({ location, children }) => {
  const isAppLoading = useSelector(selectIsAppLoading);

  useDefaultFormData(FORM_TOGGLES);
  useBrowserMonitoring(BROWSER_MONITORING_PROPS);

  return isAppLoading ? (
    <va-loading-indicator
      message={content['form-loading-text']}
      class="vads-u-margin-y--4"
      set-focus
    />
  ) : (
    <RoutedSavableApp formConfig={formConfig} currentLocation={location}>
      <DowntimeNotification
        appTitle={formConfig.subTitle}
        dependencies={formConfig.downtime.dependencies}
      >
        {children}
      </DowntimeNotification>
    </RoutedSavableApp>
  );
};

App.propTypes = {
  children: PropTypes.node,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    href: PropTypes.string,
  }),
};

export default App;
